<template>
  <v-icon>
    {{ svgPath }}
  </v-icon>
</template>

<script>
import { mdiAccountCircleOutline } from "@mdi/js";
export default {
  name: "MdiAccountCircleOutline",
  data() {
    return {
      svgPath: mdiAccountCircleOutline,
    };
  },
};
</script>
